import APIClient from '../api/apiClient'

const WhitelistService = {

	// Service to get all whitelist
	getAllWhiteList: (params) => {
		return APIClient.get(`/white-list`, { params })
	},

	// Service to delete whitelist item by ID
	deleteWhitelistEmail: (email) => {
		return APIClient.delete(`/white-list/email/${email}`)
	},

	//Upsert parking from admin
	addWhiteListEmail : (payload) => {
		return APIClient.post(`/white-list/email`, payload)
	},
}

export default WhitelistService
